import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import interior from '@/components/interior'
import Exterior from '@/components/Exterior'
import Animation from '@/components/Animation'
import VR from '@/components/VR'
import About from '@/components/About'
import Contact from '@/components/Contact'


import BackHome from '@/backHome/index'




import Grounding from "../backHome/components/grounding";
import Original from "../backHome/components/original";
import Retrieve from "../backHome/components/retrieve";
import Undercarriage from "../backHome/components/undercarriage";

//登录
import login from '@/login/index.vue'
Vue.use(Router)

export default new Router({
    mode: 'history', // 使用history模式
  routes: [
    {
      path: '/',
      name: '首页',
      component: HelloWorld
    },
      {
        path: "/login",
        name: "登录页",
        component: login
      },
       {
        path: "/BackHome",
        name: "菜单",
        component: BackHome
      },
      {
        path: "/interior",
        name: "interior",
        component: interior
      },
      {
        path: "/Exterior",
        name: "Exterior",
        component: Exterior
      },
      {
        path: "/Animation",
        name: "Animation",
        component: Animation
      },
      {
        path: "/VR",
        name: "VR",
        component: VR
      },
      {
        path: "/About",
        name: "About",
        component: About
      },
      {
        path: "/Contact",
        name: "Contact",
        component: Contact
      },


      {
        path: "/Grounding",
        name: "参考图",
        component: Grounding
      },
       {
        path: "/Original",
        name: "上架中",
        component: Original
      },
      {
        path: "/Retrieve",
        name: "下架中",
        component: Retrieve
      },
      {
        path: "/Undercarriage",
        name: "回收站",
        component: Undercarriage
      },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js